/** Rolling window of calendar years fetched from `/api/calendar/year/:year` (includes current year). */
export const ECONOMIC_CALENDAR_SYNC_YEAR_RANGE = 8;

/**
 * Returns the calendar years to sync: `ECONOMIC_CALENDAR_SYNC_YEAR_RANGE` years ending at the reference year,
 * descending (most recent first). Example (range 4, reference 2026): `[2026, 2025, 2024, 2023]`.
 */
export function getEconomicCalendarSyncYears(reference = new Date()): readonly number[] {
  const y = reference.getFullYear();
  const out: number[] = [];
  for (let i = 0; i < ECONOMIC_CALENDAR_SYNC_YEAR_RANGE; i++) {
    out.push(y - i);
  }
  return out;
}
